// extracted by mini-css-extract-plugin
export default {"top_btn":"GoToBtn_top_btn__UoiZw","gototop":"GoToBtn_gototop__yi6uR"};